import 'moment-timezone';
export var moment = require('moment')
moment.tz.setDefault("America/Sao_Paulo");